import { render, staticRenderFns } from "./BrimePro.vue?vue&type=template&id=1ed625e1&scoped=true&"
import script from "./BrimePro.vue?vue&type=script&lang=js&"
export * from "./BrimePro.vue?vue&type=script&lang=js&"
import style0 from "./BrimePro.vue?vue&type=style&index=0&id=1ed625e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed625e1",
  null
  
)

export default component.exports